import { Modal } from "react-bootstrap";
import {customerService} from "../../services/customerService";
import { Player } from '@lordicon/react';
import React, {useEffect, useRef, useState} from "react";
import processAllIcon from '../../styles/icons/processAllIcon.json'
import {batchPaymentService} from "../../services/batchPaymentsService";
import PopoverLink from "../../shared/components/PopoverLink";
import LoadingSpinner from "../../shared/components/loadingSpinner";

interface ProcessAllModalProps {
    show: boolean;
    toggle: () => void;
    refreshData: () => void;
    data: any;
}



const ProcessAllModal: React.FC<ProcessAllModalProps> = ({ show, toggle, refreshData, data}) => {

    const playerRef = useRef<Player>(null);
    useEffect(() => {
        playerRef.current?.playFromBeginning();
    }, [show])
    const onPlayPress = () => {
        playerRef.current?.playFromBeginning();
    }
    return (
        <Modal show={show} onHide={toggle} dialogClassName={'modal-lg'} className="fade forRealModal" tabIndex={-1} aria-labelledby="processAllModal" aria-hidden="true">
            <Modal.Header className={'border-0 pb-0'}>
                <button type="button" onClick={toggle} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </Modal.Header>
            <Modal.Body>
                {data &&
                    <>
                        <div className="d-flex flex-column text-center  align-items-center">
                            <Player
                                size={100}
                                icon={processAllIcon}
                                colors={'primary:#2ca58d,secondary:#eeca66,tertiary:#57ceac'}
                                ref={playerRef}
                            />
                            <div className="d-flex flex-column">
                                <h1 className="dollar-amt">${data.totalOfSuccessfulPayments}</h1>
                                <h4 className="fw-normal mb-3">charged to {data.successfulPaymentCount} customer(s)</h4>
                            </div>
                        </div>
                        {data.failedPaymentCount > 0 && <>
                            <hr/>
                            <div className="p-1 pb-4">
                                <h3 className="ms-2 mt-4">{data.failedPaymentCount} charge(s) failed</h3>
                                <div className="estimatesTable">
                                    <table className="table table-hover table-striped align-middle m-0">
                                        <tbody>
                                        {data.paymentResults.map(x => {
                                            if(x.succeeded) return;
                                            return (
                                                <>
                                                    <tr>
                                                        <td>
                                                            {x.firstName ? `${x.firstName} ` : ''} {x.lastName}
                                                        </td>
                                                        <td>
                                                            ${x.amountCharged}
                                                        </td>
                                                        <td>
                                                            <>
                                                                Web Run Failed {' '}
                                                                <PopoverLink lastErrorMessage={x.errorMessage} linkText={'Why?'}/>
                                                            </>
                                                        </td>
                                                    </tr>
                                                </>
                                            )
                                        })
                                        }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>}
                    </>
                }
                {!data &&
                    <>
                        <LoadingSpinner/>
                    </>
                }
            </Modal.Body>
            <Modal.Footer>
                {data && <button type="button" onClick={() => {
                    refreshData();
                    toggle();
                }} className="btn btn-primary text-strong text-uppercase m-100">Done
                </button>}
            </Modal.Footer>
        </Modal>
    );
}
export default ProcessAllModal;